import { render } from "./AdminAnalysis.vue?vue&type=template&id=95a3bfd6&scoped=true"
import script from "./AdminAnalysis.vue?vue&type=script&lang=js"
export * from "./AdminAnalysis.vue?vue&type=script&lang=js"

import "./AdminAnalysis.vue?vue&type=style&index=0&id=95a3bfd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a3bfd6"]])

export default __exports__